<template>
	<span>
		<span>{{ param | maestroParamLabel }}</span>
		<span
			class="option-chip caption"
			v-for="(option, i) in options"
			:key="'option' + i">
			{{ option }}
		</span>
	</span>
</template>

<script>
export default {
	props: [ 'param' ],
	data () {
		return {
			options: []
		}
	},
	mounted () {
		if (this.param.type.indexOf('[') > -1) {
			let options = this.param.type.substring(
				this.param.type.indexOf('[') + 1,
				this.param.type.indexOf(']')
			)
			this.options = options.split(' ')
		}
	}
}
</script>

<style lang="stylus" scoped>
.option-chip
	border: 1px solid
	margin-left: 4px
	padding: 0 4px
	bottom: 3px
	position: relative
	border-radius: 2px
</style>



// WEBPACK FOOTER //
// src/components/fields/label.vue